import {MAP_CONFIG} from '../../config';

export const getCenter = (points) => {
  if (!points || points.length === 0) return ({
    lat:MAP_CONFIG.latitude,
    lng:MAP_CONFIG.longitude
  });
  const size = points.length;
  if (size === 1) return {
    lat: points[0].latitude,
    lng: points[0].longitude
  };

  let x = 0, y = 0, z = 0;
  points.map(point => {
    let lat = point.latitude * Math.PI / 180;
    let lng = point.longitude * Math.PI / 180;

    x += Math.cos(lat) * Math.cos(lng);
    y += Math.cos(lat) * Math.sin(lng);
    z += Math.sin(lat);
  });
  x = x / size;
  y = y / size;
  z = z / size;

  let centralLongitude = Math.atan2(y, x);
  let centralSquareRoot = Math.sqrt(x * x + y * y);
  let centralLatitude = Math.atan2(z, centralSquareRoot);

  return {lat:centralLatitude * 180 / Math.PI, lng: centralLongitude * 180 / Math.PI};
};


// WEBPACK FOOTER //
// ./src/components/Map/getCenterLatLng.js